// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SbpInvoiceAPIModel,
    SbpInvoiceAPIModelFromJSON,
    SbpInvoiceAPIModelFromJSONTyped,
    SbpInvoiceAPIModelToJSON,
} from './';

/**
 * 
 * @export
 * @interface SbpInvoiceSummaryAPIModel
 */
export interface SbpInvoiceSummaryAPIModel {
    /**
     * 
     * @type {SbpInvoiceAPIModel}
     * @memberof SbpInvoiceSummaryAPIModel
     */
    invoice: SbpInvoiceAPIModel;
    /**
     * 
     * @type {string}
     * @memberof SbpInvoiceSummaryAPIModel
     */
    returnUrl: string;
}

export function SbpInvoiceSummaryAPIModelFromJSON(json: any): SbpInvoiceSummaryAPIModel {
    return SbpInvoiceSummaryAPIModelFromJSONTyped(json, false);
}

export function SbpInvoiceSummaryAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SbpInvoiceSummaryAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'invoice': SbpInvoiceAPIModelFromJSON(json['invoice']),
        'returnUrl': json['returnUrl'],
    };
}

export function SbpInvoiceSummaryAPIModelToJSON(value?: SbpInvoiceSummaryAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'invoice': SbpInvoiceAPIModelToJSON(value.invoice),
        'returnUrl': value.returnUrl,
    };
}


